
import React,{Component} from 'react';
import {getMonthText,lastThreeMonths} from './lib/utils';
import {MontantInput} from './montant-input';

class MontantsLastThreeMonths extends Component {
	state = {}
	constructor(props) {
		super(props);
		lastThreeMonths.forEach( (month)=>{
			this.state[month] = '';
		})
	}
	
	changeMontant = (   montant , month) => {
		this.setState ((state)=>{
			state[month] = montant;
 			return state;

		} , ()=> { 
			this.props.handler(this.state , this.props.model)
		});
	}

	render() {
		return<>{lastThreeMonths.map( (month)=>(
			<MontantInput
				name={this.props.name+month}
				model={this.state[month]}
				modelName = {month}
				handler={this.changeMontant}
			>{this.props.label} {getMonthText(month)}</MontantInput>
		))}</>; 
	}
}

export {MontantsLastThreeMonths};